module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Copyright "), _c('span', {
    attrs: {
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("©")]), _vm._v(" 2021 by Va"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("l McDermid")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Jacket design by Becca "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Fox Design")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Jacket artwork: imageBROKER / Alamy S"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("tock Photo")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace ParaOverride-7"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rm or by any electronic or mechanical means, including in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rmation "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("orage and retrieval sy"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ems, without permission in writing "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic di"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ribution of this book or the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("cilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("itutions wishing to photocopy part or all of the work "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r classroom use, or anthology, should send inquiries to Grove Atlantic, 154 We"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatl"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("antic.com.")])])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Fir"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" published in Great Britain in 2021 by Little, Brown, an imprint of H"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("achette UK")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Published simultaneously")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3 CharOverride-2"
  }, [_vm._v(" in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Printed in the United States ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3 CharOverride-2"
  }, [_vm._v("of America")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Fir"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" Grove Atlantic hardcover edition: Oc"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("tober 2021")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Library of Congress "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Cataloging")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("in")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Publication")]), _vm._v(" data is available "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r t"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("his title.")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("ISBN "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("978")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("0")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("021")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("5902")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("eISBN "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("978")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("0")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("021")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("5903")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Atlantic Mon"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("thly Press")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("an imprint of Grov")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3 CharOverride-3"
  }, [_vm._v("e Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("154 We"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" 1"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("4th Street")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("New York"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(", NY 10011")])]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-8"
  }, [_vm._v("Di"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ributed by Publishers "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Group We")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])])]), _vm._v(" "), _c('p', {
    staticClass: "CR ParaOverride-8"
  }, [_vm._v("groveat"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("lantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f31954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-3.vue
// module id = 72
// module chunks = 0